import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Navigate } from "react-router-dom";

import LoginPage from "./pages/LoginPage";
import ForceResetPage from "./pages/ForceResetPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import AdminDashboard from "./pages/AdminDashboard";
import Unauthorized from "./pages/Unauthorized";
import UserEditPage from "./pages/UserEditPage";
import StaffPage from "./pages/StaffPage";
import LearningOutcomesEditPage from "./pages/LearningOutcomesEditPage";
import InnovationHubMainPage from "./pages/InnovationHubMainPage";
//import ITKStarterPage from "./pages/ITKStarterPage";
import ITKStarterDemoPage from "./pages/ITKStarterDemoPage"
import ITKStarterApplicationPage from "./pages/ITKStarterApplicationPage";
import ITKStarterApplicationDetailPage from "./pages/ITKStarterApplicationDetailPage";
import InnovationHubAdminPanel from "./pages/InnovationHubAdminPanel";
import AdminBannerManagement from "./pages/AdminBannerManagement";
import AdminAnnouncementManagement from "./pages/AdminAnnouncementManagement";
import AdminEventManagement from "./pages/AdminEventManagement";
import EventsPage from "./pages/EventsPage";
import AdminModarationManagement from "./pages/AdminModarationManagement";
import ResearchProjectPage from "./pages/ResearchProjectPage";
import ResearchProjectApplicationPage from "./pages/ResearchProjectApplicationPage";
import ResearchProjectDetailPage from "./pages/ResearchProjectDetailPage";
import MentorSessionsManagement from "./pages/MentorSessionsManagement";
import TrainingSessionsManagement from "./pages/TrainingSessionsManagement";
import MyResearchProjectsPage from "./pages/MyResearchProjectsPage";
import ResearchPaperDetailPage from "./pages/ResearchPaperDetailPage";
import KvkkPage from "./pages/KvkkPage";
import ApplicationClosedPage from "./pages/ApplicationClosedPage";



import ProtectedRoute from "./routes/ProtectedRoute";
import RoleRoute from "./routes/RoleRoute";
import ForceResetRoute from "./routes/ForceResetRoute";
import AdminUsersTeamsManagement from "./pages/AdminUsersTeamsManagement";

function AppRoutes() {
  const { isLoggedIn, loading } = useAuth();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<InnovationHubMainPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/force-reset" element={<ForceResetPage />} />
        <Route path="/yetkisiz" element={<Unauthorized />} />
        {/* <Route path="/user-edit" element={<UserEditPage />} /> */}
        <Route path="/starter-applications/:id" element={<ITKStarterApplicationDetailPage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/innovation-hub" element={<InnovationHubMainPage />} />
        <Route path="/itk-starter" element={<ITKStarterDemoPage />} />
        <Route path="/research-projects" element={<ResearchProjectPage />} />
        <Route path="/research-projects/:id" element={<ResearchProjectDetailPage />} />
        <Route path="/research-papers/:id" element={<ResearchPaperDetailPage />} />
        <Route path="/kvkk" element={<KvkkPage />} />

        <Route
          path="/starter-application"
          element={
            loading ? (
              <div>Loading...</div>
            ) : isLoggedIn ? (
              <ApplicationClosedPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/research-project-application"
          element={
            loading ? (
              <div>Loading...</div>
            ) : isLoggedIn ? (
              <ResearchProjectApplicationPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/my-research-projects"
          element={
            loading ? (
              <div>Loading...</div>
            ) : isLoggedIn ? (
              <MyResearchProjectsPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        {/* <Route
          path="/admin-dashboard"
          element={
            <ProtectedRoute>
              <ForceResetRoute>
                <RoleRoute allowedRoles={["admin"]}>
                  <AdminDashboard />
                </RoleRoute>
              </ForceResetRoute>
            </ProtectedRoute>
          }
        /> */}

        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <ForceResetRoute>
                <RoleRoute allowedRoles={["admin", "mentor", "instructor", "supervisor"]}>
                  <InnovationHubAdminPanel />
                </RoleRoute>
              </ForceResetRoute>
            </ProtectedRoute>
          }
        />

        {/* <Route
          path="/staff-page"
          element={
            <ProtectedRoute>
              <ForceResetRoute>
                <RoleRoute
                  allowedRoles={[
                    "teacher",
                    "department_head",
                    "principal",
                    "vice_principal",
                    "staff",
                  ]}
                >
                  <StaffPage />
                </RoleRoute>
              </ForceResetRoute>
            </ProtectedRoute>
          }
        /> */}

        {/* <Route
          path="/curriculum-edit"
          element={
            <ProtectedRoute>
              <ForceResetRoute>
                <RoleRoute allowedRoles={["admin"]}>
                  <LearningOutcomesEditPage />
                </RoleRoute>
              </ForceResetRoute>
            </ProtectedRoute>
          }
        /> */}

        <Route
          path="/admin/banner"
          element={
            <ProtectedRoute>
              <ForceResetRoute>
                <RoleRoute allowedRoles={["admin"]}>
                  <AdminBannerManagement />
                </RoleRoute>
              </ForceResetRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/announcements"
          element={
            <ProtectedRoute>
              <ForceResetRoute>
                <RoleRoute allowedRoles={["admin"]}>
                  <AdminAnnouncementManagement />
                </RoleRoute>
              </ForceResetRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users-teams"
          element={
            <ProtectedRoute>
              <ForceResetRoute>
                <RoleRoute allowedRoles={["admin"]}>
                  <AdminUsersTeamsManagement />
                </RoleRoute>
              </ForceResetRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/events"
          element={
            <ProtectedRoute>
              <ForceResetRoute>
                <RoleRoute allowedRoles={["admin"]}>
                  <AdminEventManagement />
                </RoleRoute>
              </ForceResetRoute>
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/moderation"
          element={
            <ProtectedRoute>
              <ForceResetRoute>
                <RoleRoute allowedRoles={["admin", "supervisor"]}>
                  <AdminModarationManagement />
                </RoleRoute>
              </ForceResetRoute>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/mentor-sessions"
          element={
            <ProtectedRoute allowedRoles={["admin", "mentor"]}>
              <MentorSessionsManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/training-sessions"
          element={
            <ProtectedRoute allowedRoles={["admin", "instructor"]}>
              <TrainingSessionsManagement />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}